import addValidator from './add-validator';

/* eslint-disable */
const REG_EMAIL =
	/^([a-zA-Z0-9_\-\.&+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,16}|[0-9]{1,3})(\]?)$/;
/* eslint-enable */

export default addValidator({
	defaultMessage: 'invalidEmail',
	validator(options, value) {
		return REG_EMAIL.test(value);
	},
});
